import { render, staticRenderFns } from "./not-assign.vue?vue&type=template&id=d5c67a86&"
import script from "./not-assign.vue?vue&type=script&lang=js&"
export * from "./not-assign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports